<template>
  <section>
    <ol class="steps-wrapper">
      <template v-for="(step, index) in steps">
        <li class="img-block" :key="index">
          <Step :text="step.text" :img="step.img" />
        </li>
        <div
          :key="`dot-${index}`"
          v-if="index !== steps.length - 1"
          class="step-separator"
          :class="`step-separator-${index}`"
        >
          <img src="@/assets/images/icon/dblArrowRight.png" />
        </div>
      </template>
    </ol>
  </section>
</template>

<script>
import Step from './Step.vue';

export default {
  name: 'StepsSection',
  components: {
    Step
  },
  props: {
    steps: {
      type: Array,
      default: function () {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/overview/stepsSection.scss';
</style>
